import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Add global error handler to prevent app crashes
const ErrorBoundary = ({ children }) => {
  const [hasError, setHasError] = React.useState(false);

  React.useEffect(() => {
    const handleError = (error) => {
      console.error('Caught unhandled error:', error);
      setHasError(true);
    };

    const handleUnhandledRejection = (event) => {
      console.error('Caught unhandled promise rejection:', event.reason);
      
      // Safely check error message
      let errorMessage = '';
      try {
        errorMessage = event.reason?.message || event.reason?.toString() || '';
      } catch (e) {
        errorMessage = 'Unknown error';
      }
      
      // Only set error state for critical errors, not network issues
      const isCriticalError = errorMessage.includes('Cannot read properties') ||
                             errorMessage.includes('TypeError') ||
                             errorMessage.includes('ReferenceError') ||
                             errorMessage.includes('match');
      
      if (isCriticalError) {
        setHasError(true);
      }
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  if (hasError) {
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '100vh', 
        padding: '20px',
        textAlign: 'center',
        color: 'white',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      }}>
        <h1 style={{ marginBottom: '20px' }}>Something went wrong</h1>
        <p style={{ marginBottom: '30px' }}>We're sorry, but an error occurred. Please try refreshing the page.</p>
        <button 
          onClick={() => window.location.reload()} 
          style={{
            padding: '12px 24px',
            background: 'rgba(255, 255, 255, 0.2)',
            border: 'none',
            borderRadius: '8px',
            color: 'white',
            fontSize: '16px',
            cursor: 'pointer'
          }}
        >
          Refresh Page
        </button>
      </div>
    );
  }

  return children;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
